export default "__VITE_ASSET__Dto08rcG__"